export default __webpack_public_path__ + "static/media/1924.9c841b4f.png";